/**
 * Created by Angelika on 03.11.2017.
 */
import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import PropTypes from "prop-types";
import * as def from '../constants/defines';
import * as strings from '../constants/strings';
import * as ChannelsActions from '../actions/channels';
import AppMenu from './AppMenu';
import PortalContainer from '../components/PortalContainer';
import PreviewTopMenu from '../components/PreviewTopMenu';
import VideoBlock from './VideoBlock';

class Layout extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mobileMenuShow: false
        }
    }

    onClosePreviewClick() {
        const {channelsActions} = this.props;
        channelsActions.resetChannelActive();
    }

    showPreview() {
        const {activeChannel, video, channelLink, appContent: {activeFrame}} = this.props;
        return (activeChannel && channelLink.url !== null && activeFrame !== def.PLAYER_FRAME && !video.hasError && !video.isMobile);
    }

    doShowMenu() {
        this.setState({mobileMenuShow: !this.state.mobileMenuShow});
    }

    render() {
        const {activeChannel, video: {isMobile}} = this.props;
        return (
            <div className="main-content">
                {this.state.mobileMenuShow && <div className="dimmer"></div>}
                <div className={"action menu " + (this.state.mobileMenuShow ? "close" : "")} onClick={this.doShowMenu.bind(this)}>
                    {!this.state.mobileMenuShow && strings.STR_MENU}
                </div>
                <AppMenu
                    mobileMenuShow={this.state.mobileMenuShow}
                    clickMenu={this.doShowMenu.bind(this)} />
                <div className={"app-content " + (isMobile ? "isMobile" : "")}>
                    <div className="wrapper">
                        {this.props.children}
                    </div>
                </div>
                {this.showPreview() &&
                    <PortalContainer>
                        <div id="channel-preview">
                            <PreviewTopMenu activeChannel={activeChannel} onClosePreviewClick={this.onClosePreviewClick.bind(this)} />
                            <VideoBlock preview={true} />
                        </div>
                    </PortalContainer>}
            </div>
        );
    }
}

Layout.propTypes = {
    activeChannel: PropTypes.object,
    appContent: PropTypes.object,
    channelLink: PropTypes.object
};

const mapStateToProps = state => {
    return {
        activeChannel: state.channels.activeChannel,
        video: state.video,
        channelLink: state.channelLink,
        appContent: state.appContent
    }
};

const mapDispatchToProps = dispatch => {
    return {
        channelsActions: bindActionCreators(ChannelsActions, dispatch)
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Layout);


// WEBPACK FOOTER //
// ./src/containers/Layout.js